import {
  Smartphone, HeartPulse, Briefcase, GraduationCap, Home, TrendingUp,
  Stethoscope, PawPrint, UtensilsCrossed, Cpu, CreditCard, Sprout, Palette,
  Clapperboard, HeartHandshake, Smile, BadgeCheck, Gem, Copy, Store, MapPin,
  Puzzle, Blocks, Plug, LayoutTemplate, MousePointerClick, ClipboardList,
  Landmark, Network, Rocket, CalendarDays, Lock, Boxes, BrainCircuit,
  LayoutGrid, Orbit, Coins, Settings, Megaphone, Sparkles, Lightbulb,
} from "lucide-react";

const MAP = {
  Smartphone, HeartPulse, Briefcase, GraduationCap, Home, TrendingUp,
  Stethoscope, PawPrint, UtensilsCrossed, Cpu, CreditCard, Sprout, Palette,
  Clapperboard, HeartHandshake, Smile, BadgeCheck, Gem, Copy, Store, MapPin,
  Puzzle, Blocks, Plug, LayoutTemplate, MousePointerClick, ClipboardList,
  Landmark, Network, Rocket, CalendarDays, Lock, Boxes, BrainCircuit,
  LayoutGrid, Orbit, Coins, Settings, Megaphone, Sparkles, Lightbulb,
};

export const getIcon = (name) => MAP[name] || Lightbulb;
